import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import UpdateImpersonatePersonMutation from '../../mutations/mission_control/update_impersonate_person_mutation';
import MissionControlHeader from './mission_control_header';
import SelectInput from '../../components/inputs/select_input';
import {cloneDeep} from 'lodash';
import Util from '../../forecast-app/shared/util/util';
import {permissions} from '../../constants';

class impersonate extends Component {
	onChange(personId, value) {
		Util.CommitMutation(UpdateImpersonatePersonMutation, {
			id: personId,
			impersonatePerson: value === null || value.value.includes('none') ? null : value.value,
		});

		// Hubspot remove cookie
		document.cookie = 'hubspotutk=; Max-Age=-99999999;domain=.forecast.it;';
		document.cookie = '__hstc=; Max-Age=-99999999;domain=.forecast.it;';
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		if (!this.props.viewer.missionControlData.forecastPersons) {
			return null;
		}

		const sortedOtherPersons = cloneDeep(this.props.viewer.missionControlData.otherPersons).sort((a, b) => {
			if (a.companyName.toUpperCase() < b.companyName.toUpperCase()) return -1;
			if (a.companyName.toUpperCase() > b.companyName.toUpperCase()) return 1;
			return 0;
		});

		const padString = '                                                                               ';

		const longest_company_name = sortedOtherPersons.reduce((total, el) => (total < el.companyName.length ? el.companyName.length : total), 0);
		const longest_name = sortedOtherPersons.reduce((total, el) => (total < `${el.firstName} ${el.lastName}`.length ? `${el.firstName} ${el.lastName}`.length : total), 0);
		const permission_length = 17;

		const options = sortedOtherPersons.map(op => {
			const value = op.id;
			const name = op.firstName + ' ' + op.lastName; //.replace(/ /g, '@42@');
			const permission = permissions.find(p => p.value === op.userType).label;
			const label = `${(op.companyName + padString).substring(0, longest_company_name).replace(/ /g, '\u00a0')} ${(name + padString).substring(0, longest_name).replace(/ /g, '\u00a0')} ${(permission + padString)
				.substring(0, permission_length)
				.replace(/ /g, '\u00a0')} ${op.email}`.replace(/@42@/g, ' ');
			return {value: value, label: label};
		});
		options.unshift({
			value: 'none',
			label: `${('Company' + padString).substring(0, longest_company_name).replace(/ /g, '\u00a0')} ${('Name' + padString).substring(0, longest_name).replace(/ /g, '\u00a0')} ${('Permission' + padString)
				.substring(0, permission_length)
				.replace(/ /g, '\u00a0')} Email`,
		});

		return (
			<div className="mission-control-list mission-control-impersonate">
				<MissionControlHeader viewer={this.props.viewer} />
				<h1>Impersonate another person</h1>
				<table>
					<tbody>
						{this.props.viewer.missionControlData.forecastPersons.map(p => (
							<tr key={p.id} className="people-list">
								<td className="name-row">
									<h3>{p.firstName}</h3>
								</td>
								<td>
									<SelectInput
										locked={this.props.viewer.actualPersonId !== p.id && p.impersonatedPersonId !== this.props.viewer.actualPersonId}
										options={options}
										onChange={this.onChange.bind(this, p.id)}
										value={p.impersonatedPersonId || null}
										clearable={true}
										label="Select person to impersonate"
										multi={false}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

const impersonateQuery = graphql`
	query impersonate_Query {
		viewer {
			actualPersonId
			component(name: "control_impersonate")
			...impersonate_viewer
		}
	}
`;

export {impersonateQuery};

export default createFragmentContainer(withRouter(impersonate), {
	viewer: graphql`
		fragment impersonate_viewer on Viewer {
			id
			...missionControlHeader_viewer
			actualPersonId
			missionControlData {
				id
				forecastPersons {
					id
					firstName
					lastName
					impersonatedPersonId
				}
				otherPersons {
					id
					firstName
					lastName
					email
					companyName
					userType
				}
			}
		}
	`,
});
